export const SET_ENV_VARIABLE = 'ENV_VARIABLE';